import React from 'react';
import { Modal, Button } from 'react-bootstrap';


const ErrorModal = ({ show, handleClose, handleCancel, errorDescription }) => {


    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>Acumen Translation Hub says</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <p>{errorDescription}</p>
                    <p>
                        By clicking Continue you agree to our Terms & Conditions and Privacy Statement.
                        Click Cancel to exit translation
                    </p>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleCancel}>
                    Continue
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ErrorModal;
